import {
  AlertDialog,
  DialogContainer,
  Flex,
  Text,
} from "@adobe/react-spectrum";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { ReceivedGroupRequestsPath } from "../../constants/Routes";

export default function ConfirmCountryDialog({
  openDialog,
  setOpen,
  selectedRequest,
  handleApproval,
}) {
  const [requestPayload, setRequestPayload] = useState({
    status: "",
    statusReason: "",
    approverEmail: "",
    approverName: "",
  });

  const history = useHistory();

  useEffect(() => {
    setRequestPayload((prev) => ({
      ...prev,
      status: selectedRequest?.status,
      approverEmail: selectedRequest?.approverEmail,
      approverName: selectedRequest?.approverName,
    }));
  }, [selectedRequest]);

  return (
    <DialogContainer onDismiss={setOpen}>
      {openDialog && (
        <AlertDialog
          title="Approve Request"
          variant="destructive"
          primaryActionLabel="Yes"
          cancelLabel="No"
          onPrimaryAction={() =>
            handleApproval(selectedRequest?.requestId, requestPayload)
          }
          onCancel={() => {
            history.push(ReceivedGroupRequestsPath);
          }}
        >
          <Flex direction="column" gap="size-150">
            <Text>
              In alignment with DOJ ruling, Admins do not grant access to users
              in the following Countries of Concern (CoC) - China (including
              Hong-Kong and Macau), Russia, Iran, North Korea, Cuba, Venezuela.
              Please confirm before approving the request.
            </Text>
          </Flex>
        </AlertDialog>
      )}
    </DialogContainer>
  );
}

ConfirmCountryDialog.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  selectedRequest: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.string))
    .isRequired,
  handleApproval: PropTypes.func.isRequired,
};
